function police({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 48 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30.6667 31.5733L33.0667 41.92L24 36.4533L14.9333 41.92L17.3333 31.6L9.33333 24.6933L19.8933 23.7866L24 14.0533L28.1067 23.76L38.6667 24.6666L30.6667 31.5733ZM24 6.50663L42.6667 14.8V27.3333C42.6667 39.3866 34.72 50.5066 24 53.8133C13.28 50.5066 5.33333 39.3866 5.33333 27.3333V14.8L24 6.50663ZM24 0.666626L0 11.3333V27.3333C0 42.1333 10.24 55.9733 24 59.3333C37.76 55.9733 48 42.1333 48 27.3333V11.3333L24 0.666626Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default police;
